export const Selectors = {	partnersList: '.partners-list',	partnersLetters: '.partners-letters',	partner: '.partners-list-partner'};